module.exports = __webpack_public_path__ + "8c6c922ff0ee54697a2e54200b69ef6f.svg";